import { contacts } from '@config';
import { FaDiscord, FaEnvelope, FaFacebookF, FaGithub, FaInstagram, FaYoutube } from 'react-icons/fa6';
const Social = [{
  icon: FaFacebookF,
  href: `https://www.facebook.com/${contacts.facebook}`
}, {
  icon: FaGithub,
  href: `https://github.com/${contacts.github}`
}, {
  icon: FaYoutube,
  href: `https://www.youtube.com/${contacts.youtube}`
}, {
  icon: FaInstagram,
  href: `https://www.instagram.com/${contacts.instagram}`
}, {
  icon: FaEnvelope,
  href: `mailto:${contacts.mail}`
}, {
  icon: FaDiscord,
  href: `https://discord.gg/${contacts.discord}`
}];
const SocialContact = () => {
  return <div className='mt-0.5 flex items-center space-x-1 md:mt-1 md:space-x-2'>
      {Social.map(Item => <a className='anim-config opacity-40 hover:opacity-100' href={Item.href} key={`nav_modalInfo-${Item.href}`} rel='noopener noreferrer' target='_blank'>
          <Item.icon />
        </a>)}
    </div>;
};
export { SocialContact };